import React, { Fragment, ReactElement } from 'react';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Typography } from '@material-ui/core';
import useStyles from './styles';
import * as CurrencyUtils from 'utils/currency';

interface IMscon {
  vat_return_version_id: number;
  country_id: number;
  country: string;
  grand_total: number;
  total_msid_goods: number;
  total_msid_services: number;
  total_msest_goods: number;
  total_msest_services: number;
  due_balance: number;
  total_correction: number;
  total_amount_due: number;
}

interface IProps {
  // mode: 'VIEW' | 'EDIT';
  data: Array<IMscon>;
}

export default function VatReturnTotalAmountDue(props: IProps): ReactElement {
  // console.log('Render VatReturnTotalAmountDue');
  const classes = useStyles();

  const calculateTotal = () => {
    let total = 0;
    for (let mscon of props.data) total += mscon.total_amount_due ?? 0;
    return total;
  };

  const calculateTotalPayable = () => {
    let total = 0;
    for (let mscon of props.data) {
      total += mscon.total_amount_due > 0 ? mscon.total_amount_due : 0;
    }
    return total;
  };

  return (
    <Fragment>
      <div className={classes.header_container}>
        <Typography variant="h5" style={{ marginBottom: '.5rem' }}>
          <TranslatedText textMap={Translations.header} />
        </Typography>
      </div>
      <BlueBlockQuote>
        <span>
          <TranslatedText textMap={Translations.note} />
        </span>
      </BlueBlockQuote>
      <YellowBlockQuote>
        <div className={classes.container}>
          <TranslatedText textMap={Translations.total_vat_amount_due} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(calculateTotal())}
          </div>
        </div>
      </YellowBlockQuote>
      <GreenBlockQuote>
        <div className={classes.container} style={{ fontWeight: 'bold' }}>
          <TranslatedText textMap={Translations.total_vat_amount_payable} />
          <div className={classes.value}>
            {CurrencyUtils.formatCurrency(calculateTotalPayable())}
          </div>
        </div>
      </GreenBlockQuote>
    </Fragment>
  );
}

interface BlockQuote {
  children: any;
}
function BlueBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_blue}>{props.children}</div>;
}

function YellowBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_yellow}>{props.children}</div>;
}

function GreenBlockQuote(props: BlockQuote) {
  const styles = useStyles();
  return <div className={styles.quote_block_green}>{props.children}</div>;
}
